import type { PropsWithChildren } from 'react';

import './Alert.scss';

type AlertType = 'danger' | 'warning' | 'info' | 'success' | 'info-no-border';
type AlertProps = {
  id?: string;
  type?: AlertType;
  role?: string;
};

function Alert({
  children,
  type = 'info',
  role = 'alert',
  ...other
}: PropsWithChildren<AlertProps>) {
  return (
    <div className={`Alert Alert--${type}`} role={role} {...other}>
      {children}
    </div>
  );
}

export { Alert, type AlertType };
